export const NO_RESPONSE = 0
export const ACCEPTED = 1
export const DECLINED = 2
export const TENTATIVE = 3
export const OWNER = 4
